// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"widget-common_cardTitle__vmwnf","cardContent":"widget-common_cardContent__4eI1z"};